export class ScrollService {
  private disable: boolean = false;

  public stepScrollToTop(): void {
    setTimeout(() => {
      this.scrollTo('.stepform-step-indicator');
    }, 100);
  }

  public scrollToTop(): void {
    this.scrollTo('body');
  }

  public scrollTo(selector: string, duration: number = 200): void {
    const targetElement = document.querySelector(selector);
    this.scrollElementTo(targetElement, duration);
  }

  public scrollElementTo(targetElement: Element | null, _duration: number = 200): void {
    if (this.disable || !targetElement) {
      return;
    }

    const marginOffset = 100;
    const top = targetElement.getBoundingClientRect().top + window.scrollY - marginOffset;

    window.scrollTo({ top, behavior: 'smooth' });
  }
}
